import React from 'react';
import { useLocation } from 'react-router-dom';

function Footer() {
  const location = useLocation();
  
  // Don't show footer on home page (it has its own)
  if (location.pathname === '/') {
    return null;
  }

  return (
    <footer style={{ 
      background: '#1a1a1a',
      color: 'white',
      padding: '40px 20px',
      marginTop: '80px'
    }}>
      <div style={{ 
        maxWidth: '1600px',
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '40px'
      }}>
        <div>
          <h3 style={{ marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span>⭐</span>
            <span>QR Review</span>
          </h3>
          <p style={{ opacity: 0.7, lineHeight: '1.6' }}>
            AI-powered review generation system for businesses. 
            Boost your online reputation with smart QR codes.
          </p>
        </div>

        <div>
          <h4 style={{ marginBottom: '16px' }}>Quick Links</h4>
          <ul style={{ listStyle: 'none', padding: 0, opacity: 0.7 }}>
            <li style={{ marginBottom: '8px' }}>
              <a href="/managers" style={{ color: 'white', textDecoration: 'none' }}>Dashboard</a>
            </li>
            <li style={{ marginBottom: '8px' }}>
              <a href="/business-profile" style={{ color: 'white', textDecoration: 'none' }}>Business Profile</a>
            </li>
            <li style={{ marginBottom: '8px' }}>
              <a href="/" style={{ color: 'white', textDecoration: 'none' }}>Home</a>
            </li>
          </ul>
        </div>

        <div>
          <h4 style={{ marginBottom: '16px' }}>Features</h4>
          <ul style={{ listStyle: 'none', padding: 0, opacity: 0.7 }}>
            <li style={{ marginBottom: '8px' }}>AI Review Generation</li>
            <li style={{ marginBottom: '8px' }}>QR Code System</li>
            <li style={{ marginBottom: '8px' }}>Google Integration</li>
            <li style={{ marginBottom: '8px' }}>Real-time Analytics</li>
          </ul>
        </div>

        <div>
          <h4 style={{ marginBottom: '16px' }}>Support</h4>
          <ul style={{ listStyle: 'none', padding: 0, opacity: 0.7 }}>
            <li style={{ marginBottom: '8px' }}>📧 support@qrreview.com</li>
            <li style={{ marginBottom: '8px' }}>📱 +91 1234567890</li>
            <li style={{ marginBottom: '8px' }}>🌐 www.qrreview.com</li>
          </ul>
        </div>
      </div>

      <div style={{ 
        maxWidth: '1600px',
        margin: '40px auto 0',
        paddingTop: '20px',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        textAlign: 'center',
        opacity: 0.7
      }}>
        <p style={{ margin: 0 }}>
          © 2026 QR Review App. All rights reserved. | Made with ❤️ in India
        </p>
      </div>
    </footer>
  );
}

export default Footer;
